import { useContext } from 'react';
import { FeatureFlagContext } from '@/providers/FeatureFlagContext';
import type { EFeatureFlag } from '@/lib/feature-flags/keys';

export function useFeatureFlag(flag: EFeatureFlag) {
  const ctx = useContext(FeatureFlagContext);
  return {
    enabled: ctx.enabled[flag],
    isLoading: ctx.isLoading,
    isResolved: ctx.isResolved,
    isError: ctx.isError,
    refetch: ctx.refetch,
  };
}
